import { combineReducers } from '@reduxjs/toolkit';
import { tmBoardSlice } from 'modules/board-master/store/tm-board/tmBoard';

const masterBoardReducer = combineReducers({
  tmBoard: tmBoardSlice.reducer,
});

export default masterBoardReducer;
